'use client';

import { type FC, useContext, useMemo } from 'react';

import { SliderRootContext } from './context/slider-root.context';
import { SliderHandle } from './slider-handle';
import type { SliderHandlesPropsInterface } from './types/slider-handles.types';

/**
 * Alternative to `Slider.Handle`. Renders all appropriate handles.
 *
 * @since 10.0.0
 */
export const SliderHandles: FC<SliderHandlesPropsInterface> = () => {
  const { value } = useContext(SliderRootContext);

  const content = useMemo(() => {
    if (typeof value === 'number') {
      return <SliderHandle />;
    }
    return value.map((_, i) => <SliderHandle key={`c11n-slider-handle-${i}`} />);
  }, [value]);

  return content;
};

SliderHandles.displayName = 'Slider.Handles';
